// @ts-nocheck
import {
  tsValueToJsonValueFns,
  jsonValueToTsValueFns,
} from "@pbkit/runtime/json/scalar";
import {
  WireMessage,
} from "@pbkit/runtime/wire/index";
import {
  default as serialize,
} from "@pbkit/runtime/wire/serialize";
import {
  tsValueToWireValueFns,
  wireValueToTsValueFns,
} from "@pbkit/runtime/wire/scalar";
import {
  default as deserialize,
} from "@pbkit/runtime/wire/deserialize";

export declare namespace $.google.protobuf {
  export type Timestamp = {
    seconds: string;
    nanos: number;
  }
}

export type Type = $.google.protobuf.Timestamp;

export function getDefaultValue(): $.google.protobuf.Timestamp {
  return {
    seconds: "0",
    nanos: 0,
  };
}

export function createValue(partialValue: Partial<$.google.protobuf.Timestamp>): $.google.protobuf.Timestamp {
  return {
    ...getDefaultValue(),
    ...partialValue,
  };
}

export function encodeJson(value: $.google.protobuf.Timestamp): unknown {
  const result: any = {};
  if (value.seconds !== undefined) result.seconds = tsValueToJsonValueFns.int64(value.seconds);
  if (value.nanos !== undefined) result.nanos = tsValueToJsonValueFns.int32(value.nanos);
  return result;
}

export function decodeJson(value: any): $.google.protobuf.Timestamp {
  const result = getDefaultValue();
  if (value.seconds !== undefined) result.seconds = jsonValueToTsValueFns.int64(value.seconds);
  if (value.nanos !== undefined) result.nanos = jsonValueToTsValueFns.int32(value.nanos);
  return result;
}

export function encodeBinary(value: $.google.protobuf.Timestamp): Uint8Array {
  const result: WireMessage = [];
  if (value.seconds !== undefined) {
    const tsValue = value.seconds;
    result.push(
      [1, tsValueToWireValueFns.int64(tsValue)],
    );
  }
  if (value.nanos !== undefined) {
    const tsValue = value.nanos;
    result.push(
      [2, tsValueToWireValueFns.int32(tsValue)],
    );
  }
  return serialize(result);
}

export function decodeBinary(binary: Uint8Array): $.google.protobuf.Timestamp {
  const result = getDefaultValue();
  const wireMessage = deserialize(binary);
  const wireFields = new Map(wireMessage);
  field: {
    const wireValue = wireFields.get(1);
    if (wireValue === undefined) break field;
    const value = wireValueToTsValueFns.int64(wireValue);
    if (value === undefined) break field;
    result.seconds = value;
  }
  field: {
    const wireValue = wireFields.get(2);
    if (wireValue === undefined) break field;
    const value = wireValueToTsValueFns.int32(wireValue);
    if (value === undefined) break field;
    result.nanos = value;
  }
  return result;
}
